import { Button } from "@hoylu/client-common";
import React from "react";
import Styles from "./RemoveButton.module.css";

export type RemoveButtonProps = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
};

export const RemoveButton = ({
  text,
  onClick,
  disabled,
}: RemoveButtonProps) => {
  return (
    <Button
      classNames={[Styles.removeButton]}
      disabled={disabled}
      onClick={onClick}
      type="secondary"
    >
      <div className="hoylu-ui-icons-incomplete" />
      {`${text}...`}
    </Button>
  );
};
